// removed by extract-text-webpack-plugin


/*****************
 ** WEBPACK FOOTER
 ** ./LeLab.LogAlto.Web/src/modules/section/jumbotron/jumbotron.scss
 ** module id = 122
 ** module chunks = 0 1
 **/